var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.202,
    height: 11.202,
    viewBox: "0 0 11.202 11.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-id-svgrepo-com",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M6.387,18.411C3.6,18.411,3,17.813,3,15.024",
    transform: "translate(-3 -8.209)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M18.411,15.024c0,2.789-.6,3.387-3.387,3.387",
    transform: "translate(-8.209 -8.209)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M15.024,3c2.789,0,3.387.6,3.387,3.387",
    transform: "translate(-8.209 -3)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M8,14a2.834,2.834,0,0,0,4.535,0",
    transform: "translate(-5.166 -7.765)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M9,10.006V10",
    transform: "translate(-5.599 -6.032)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M15,10.006V10",
    transform: "translate(-8.199 -6.032)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M3,6.387C3,3.6,3.6,3,6.387,3",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceShareIcon);
export default __webpack_public_path__ + "static/media/face-share-icon.5a4145560efd6bc19350fe5dcb4ae293.svg";
export { ForwardRef as ReactComponent };